import React, {useEffect, useState} from 'react';
import FamilyMemberCellularSaleError from '../../FamilyMemberCellularSaleBlock/FamilyMemberCellularSaleError';
import {connect} from 'react-redux';

const FamilyPackageErrorPage = (props) => {
  const familyPackagesData = props.welcomeBlock.familyPackagesData;
  return (
    <>
      {!props.cellularPackageList ? (
        <FamilyMemberCellularSaleError title={'מצטערים, פעולה זו לא אפשרית'} />
      ) : (
        <FamilyMemberCellularSaleError
          title={`מימשת ${familyPackagesData.used}/${familyPackagesData.used} הטבות לחבילות מיוחדות לבני משפחת ${props.welcomeBlock.organizationState?.name}`}
          subtitle={`לקבלת מידע נוסף ועזרה יש לפנות לאיש הקשר`}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cellularPackageList: state.selfcarePage?.organizationState?.cellularPackageList,
    welcomeBlock: state.welcomeBlock,
  };
};

export default connect(mapStateToProps)(FamilyPackageErrorPage);
